import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { TwoFactorAuthenticationPopup } from '../TwoFactorAuthenticationPopup';

const popupId = uuid();

export const showTwoFactorAuthenticationPopupAction = (data = {}) => addPopupAction({
    id: popupId,
    layer: LAYER.SESSION_VALIDATION,
    component: TwoFactorAuthenticationPopup,
    ...data
});
